import { Pipe, PipeTransform } from '@angular/core';

/** Transforms lines of code to an html representation. */
@Pipe({
  name: 'rdsLocHtml',
})
export class RdsLocHtmlPipe implements PipeTransform {
  transform(loc: string[]): string {
    if (!loc || !loc.length) {
      return '';
    }
    return loc.join('<br />');
  }
}
